// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"245cc5a0","581":"b20f05a2","658":"dd94c4d9","716":"bad72f01"}[chunkId] + ".js";
};